import { pxToRem } from '@anwb/poncho/design-tokens/style-utilities';
import styled from 'styled-components';

export const UitrustingLinkContentContainer = styled.div`
	margin-top: ${({ theme }) => pxToRem(theme.spacing['100'])};
	margin-bottom: ${({ theme }) => pxToRem(theme.spacing['400'])};
`;
